import React from 'react';

// components
import Chatbot from './components/chatbot/chatbot.component';

import './App.css';

const App = () => (
  <Chatbot />
)

export default App;
